// Klasser för ajax POST-responser, som motsvarar diton i C#:




/*


 Obs! Dessa måste överensstämma *exakt* (mer eller mindre) med resultatet av en konvertering av motsvarande C#-klasser till Json (return Json(...) i actions)!!!
 Bl.a. att de har inledande versaler på proparna (C# naming convention).






*/






//###################################################################################################

class ResultatMessageClass
{
	constructor(field, messageTextOrHtml,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			succeeded = false,
			details = null,
			code = null,
			exceptionType = null,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		console.assert(typeof field === 'string',
			'Parametern \'field\' är obligatorisk och måste vara av typen \'string\''
		);

		console.assert(typeof messageTextOrHtml === 'string',
			'Parametern \'messageTextOrHtml\' är obligatorisk och måste vara av typen \'string\''
		);

		console.assert(typeof succeeded === 'boolean',
			'Parametern \'succeeded\' måste vara en boolean.'
		);

		console.assert(!details || typeof details === 'string',
			'Parametern \'details\' måste vara av typen \'string\' (eller null/undefined).'
		);

		console.assert(!code || typeof code === 'string',
			'Parametern \'code\' måste vara av typen \'string\' (eller null/undefined).'
		);

		console.assert(!exceptionType || typeof exceptionType === 'string',
			'Parametern \'exceptionType\' måste vara av typen \'string\' (eller null/undefined).'
		);

		// ---------------------------------------------------------------------------

		this.Succeeded = succeeded;

		this.Field = field;
		this.MessageTextOrHtml = messageTextOrHtml;

		this.Details = details;
		this.Code = code;
		this.ExceptionType = exceptionType;
	}

	// ==========================================================

	//// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen ResultatClass):
	//// Obs! Denna "castar" *endast* rotobjektet, inte nästade underobjekt/arrayvärden.
	//static castFrom(obj)
	//{ }

	// == Beräknade properties: ========================================================

	get Failed()
	{
		return !this.Succeeded;
	}

	// Todo: Not yet implemented:
	//public string MessageAsHtml => _byggMessageAsHtml();
	//public string MessageAsVerboseHtml => _byggMessageAsHtml(verbose: true);
	//public string MessageAsPlainText => MessageAsHtml?.StädaBortAllaHtmltaggar();
}


//###################################################################################################

class ResultatClass
{
	constructor(succeeded,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			messages = null,
			customData = null,
		}
			= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		console.assert(typeof succeeded === 'boolean',
			'Parametern \'succeeded\' är obligatorisk och måste vara en boolean.'
		);

		console.assert(!messages || messages instanceof Array,
			'Parametern \'messages\' måste vara av typen \'Array\' (eller null/undefined).'
		);

		console.assert(!Array.isArray(messages) || messages.every(val => val instanceof ResultatMessageClass),
			'Alla värden i arrayen \'messages\' måste vara av typen \'ResultatMessageClass\'.'
		);

		console.assert(!customData || customData instanceof Object,
			'Parametern \'customData\' måste vara av typen \'Object\' (eller null/undefined).'
		);

		// ---------------------------------------------------------------------------

		this.Succeeded = succeeded;
		this.Messages = messages;
		this.CustomData = customData;
	}

	// ==========================================================

	// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen ResultatClass):
	// Obs! Denna "castar" *endast* rotobjektet, inte nästade underobjekt/arrayvärden.
	static castFrom(obj)
	{
		// Todo: Obs! Denna borde *egentligen* hantera nästade objekt/arrayvärden (ResultatMessageClass), se castAlsoNestedObjectsAndArrayValues i euiPopUpMenyClasses m.fl., men eftersom undertypen i sig endast är ett POCO utan metoder e.d. så behövs det inte riktigt, så vi skjuter det på framtiden!

		let ny = new ResultatClass(false);
		ny = Object.assign(ny, obj);
		return ny;
	}

	// == Beräknade properties: ========================================================

	get Failed()
	{
		return !this.Succeeded;
	}

	get AntalMessages()
	{
		return (this.Messages ? this.Messages.length : 0);
	}


	get AllMessagesAsHtml()
	{
		return this._byggAllMessagesAsHtml();
	}

	get AllMessagesAsVerboseHtml()
	{
		return this._byggAllMessagesAsHtml({ verbose: true });
	}


	// == Helpers: =====================================================================
	// "Private" helpers:

	_byggAllMessagesAsHtml(
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			verbose = false,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		if (this.AntalMessages >= 1)
		{
			let meddelandeHtml = '';

			for (const meddelande of this.Messages)
			{
				// Simpel detektering om meddelandetexten behöver omslutas av en <p></p>:
				// Regex: "(ev) inledande whitespace/radbrytningar följda av '<'"
				let msgTagged = (/^[\s\n\r]*</.test(meddelande.MessageTextOrHtml) ?
					meddelande.MessageTextOrHtml :
					`<p>${meddelande.MessageTextOrHtml}</p>`
				);

				if (this.Failed && meddelande.Field !== '')
				{
					meddelandeHtml += `<p class="liten -gra-text">Fältet ${meddelande.Field}:</p>`;
				}

				meddelandeHtml += msgTagged;

				if (verbose)
				{
					if (meddelande.Details)
					{
						meddelandeHtml += '<p class="liten -gra-text">Detaljer:</p>';
						meddelandeHtml += `<p class="liten -gra-text">${meddelande.Details.replace(/[\n\r]?/, ' <br> ')}</p>`;
					}

					if (meddelande.Code)
						meddelandeHtml += `<p class="liten -gra-text">Kod: ${meddelande.Code}</p>`;

					if (meddelande.ExceptionType)
						meddelandeHtml += `<p class="liten -gra-text">Typ av exception: ${meddelande.ExceptionType}</p>`;
				}
			}

			return meddelandeHtml;
		}
		else
		{
			if (this.Failed)
				return '<p>Ett oväntat fel inträffade. Ingen vidare information om felet finns.</p>';

			return null;
		}
	}

}


export default {
	Resultat: ResultatClass,
	ResultatMessage: ResultatMessageClass,
};

export { ResultatClass as Resultat };
export { ResultatMessageClass as ResultatMessage };
